import { httpService } from '../http.service.js'
import { utilService } from './../util.service.js'

const CACHE_EXPIRY_DAYS = 14 // 🔹 תוקף המטמון - שבועיים
const CACHE_EXPIRY_TIME = CACHE_EXPIRY_DAYS * 24 * 60 * 60 * 1000 // זמן במילישניות
const GROUP_SIZE = 5 // 🔹 מספר עובדות שיוצגו בכל פעם

let cache = {} // 🔹 קאש בזיכרון

export const factService = {
  fetchFacts,
}

// 📌 **משיכת עובדות (Facts) עם מטמון חכם**
async function fetchFacts() {
  const cacheKey = 'factsData'
  const cacheExpirationKey = 'factsDataExpiration'
  const groupIndexKey = 'currentFactGroupIndex'
  const now = Date.now()

  let currentGroupIndex = utilService.getFromLocalStorage(groupIndexKey) || 0

  // 🔹 1️⃣ בדיקה בקאש בזיכרון (RAM)
  if (cache[cacheKey]) {
    return getFactGroup(cache[cacheKey], currentGroupIndex)
  }

  // 🔹 2️⃣ בדיקה בלוקאל סטורג'
  const cachedData = utilService.getFromLocalStorage(cacheKey)
  const cachedExpiration = utilService.getFromLocalStorage(cacheExpirationKey)

  if (cachedData && cachedExpiration && now < cachedExpiration) {
    cache[cacheKey] = cachedData // ✅ שומרים גם ב-RAM
    return getFactGroup(cachedData, currentGroupIndex)
  }

  // 🔹 3️⃣ אם הנתונים לא נמצאים או פגו תוקף → מביאים מהשרת
  const allFacts = await fetchFactsFromServer()

  if (allFacts.length) {
    // ✅ שמירת הנתונים בזיכרון RAM
    cache[cacheKey] = allFacts

    // ✅ שמירת הנתונים ב-LocalStorage
    utilService.saveToLocalStorage(cacheKey, allFacts)
    utilService.saveToLocalStorage(cacheExpirationKey, now + CACHE_EXPIRY_TIME)

    // ✅ עדכון האינדקס לקבוצה הבאה
    currentGroupIndex = (currentGroupIndex + 1) % Math.ceil(allFacts.length / GROUP_SIZE)
    utilService.saveToLocalStorage(groupIndexKey, currentGroupIndex)
  }

  return getFactGroup(allFacts, currentGroupIndex)
}

// 📌 **שליפת העובדות מהשרת**
async function fetchFactsFromServer() {
  try {
    const data = await httpService.get('animefeatures/facts')

    return data
  } catch (error) {
    console.error('❌ שגיאה בשליפת הנתונים מהשרת:', error)
    return []
  }
}

// 📌 **מחזיר קבוצה מסוימת של עובדות מהמאגר**
function getFactGroup(factList, index) {
  const startIndex = index * GROUP_SIZE
  const endIndex = startIndex + GROUP_SIZE
  return factList.slice(startIndex, endIndex)
}
